import { Textarea } from "@/components/ui/textarea";
import { ScorePicker } from "@/components/wizard/controls";

export const StepCompetencies = ({ f, set, list }) => {
  const update = (key, patch) => set("competencies", { ...f.competencies, [key]: { notes: "", ...f.competencies[key], ...patch } });
  return (
    <div className="space-y-4" data-testid="step-competencies">
      <p className="text-sm text-muted-foreground">Score each competency as observed on the road during the ride. Nothing is tested in isolation.</p>
      {list.map((c, i) => {
        const cur = f.competencies[c.key] || {};
        return (
          <section key={c.key} data-testid={`competency-${c.key}`} className={`space-y-3 rounded-2xl border bg-card p-5 ${cur.score === 2 ? "border-l-4 border-l-destructive" : cur.score === 1 ? "border-l-4 border-l-emerald-500" : ""}`}>
            <div>
              <div className="font-mono text-xs text-primary">{String(i + 1).padStart(2, "0")} / {String(list.length).padStart(2, "0")}</div>
              <h3 className="text-base font-bold">{c.title}</h3>
              <p className="text-sm text-muted-foreground">{c.desc}</p>
            </div>
            <ScorePicker value={cur.score} onChange={(s) => update(c.key, { score: s })} testId={`score-${c.key}`} />
            <Textarea rows={2} placeholder="Observations (optional)" value={cur.notes || ""} onChange={(e) => update(c.key, { notes: e.target.value })} data-testid={`notes-${c.key}`} />
          </section>
        );
      })}
    </div>
  );
};
